import type { PromoAdInput } from '@shared/api/graphql/generated';

export const serializePromoAdInputs = (promos: readonly PromoAdInput[]): PromoAdInput[] =>
  promos.map(({ promoId, promoAdId, videoPromoId, time, playDuration, withSound }) => ({
    promoId,
    promoAdId: promoAdId || undefined,
    videoPromoId: videoPromoId || undefined,
    time: time ?? undefined,
    playDuration: playDuration ?? undefined,
    withSound: withSound ?? undefined,
  }));
